import { ProviderReportActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { successType } from 'src/services/api-handlers/api-resolver';
//import {ProviderReportFormData} from 'src/screens/General/screens/ProviderReports/components/ProviderReportForm';

export interface GetProviderReportsAction {
    type: typeof ProviderReportActions.FETCH_PROVIDER_REPORTS;
    payload: any;
    all?: any;
}

export function getProviderReports(params: any): GetProviderReportsAction {
    return {
        type: ProviderReportActions.FETCH_PROVIDER_REPORTS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getProviderReportsCsv(params: QueryParamsAll): GetProviderReportsAction {
    return {
        type: ProviderReportActions.FETCH_PROVIDER_REPORTS_CSV,
        payload: params,
    };
}

export function getProviderReportsTotal(params: QueryParamsAll): GetProviderReportsAction {
    return {
        type: ProviderReportActions.FETCH_PROVIDER_REPORTS_TOTAL,
        payload: params,
    };
}
export function clearTotal(): any {
    return {
        type: successType(ProviderReportActions.FETCH_PROVIDER_REPORTS_TOTAL),
        payload: {},
        total: true,
    };
}

export interface GetProviderReportAction {
    type: typeof ProviderReportActions.FETCH_PROVIDER_REPORT;
    payload: {
        id: string | number;
    };
}

export function getProviderReport(id: string | number): GetProviderReportAction {
    return {
        type: ProviderReportActions.FETCH_PROVIDER_REPORT,
        payload: { id },
    };
}

export interface DeleteProviderReportAction {
    type: typeof ProviderReportActions.DELETE_PROVIDER_REPORT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteProviderReport(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteProviderReportAction {
    return {
        type: ProviderReportActions.DELETE_PROVIDER_REPORT,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetProviderReportsAction | GetProviderReportAction | DeleteProviderReportAction;
